import CognitoProvider from 'aws-sdk/clients/cognitoidentityserviceprovider';

export function getUserAttribute(
  name: string,
  attributes?: CognitoProvider.AttributeListType
) {
  return attributes?.find((attr) => attr.Name === name)?.Value || null;
}
